import { roundNumber } from "helpers";
import { MeteringPointMeasurements, MeteringPointMeasurementsDataPoint } from "models/electricity/metering-point";
import moment from "moment"
import React from "react"
import Chart from 'react-apexcharts'
import { Spinner } from "react-bootstrap";

interface ElectricityConsumptionChartProps {
    measurementData?: MeteringPointMeasurements;
    loading: boolean;
    onDataPointClick: (measurement: MeteringPointMeasurementsDataPoint) => void;
}

export default function ElectricityConsumptionChart({ measurementData, loading, onDataPointClick }: ElectricityConsumptionChartProps) {

    let format = 'HH:mm';
    if (measurementData?.resolution === 'DAY') {
        format = 'DD.MM';
    } else if (measurementData?.resolution === 'MONTH') {
        format = 'MMM YY';
    }
    
    const series = [{
        name: 'Tarbimine kWh',
        data: measurementData?.measurements?.map((m: any) => roundNumber(m.consumptionKwh, 3)) || []
    }];
    if (measurementData?.measurements?.some(m => m.productionKwh)) {
        series.push({
            name: 'Tootmine kWh',
            data: measurementData?.measurements?.map((m: any) => roundNumber(m.productionKwh, 3))
        });
    }

    return (
        <div className="d-flex bg-white rounded p-3">
            { loading ? <Spinner animation="grow" className="mx-auto my-5" /> : null }
            { measurementData && !loading ? <div className="w-100">
                <Chart options={{
                states: {
                    active: {
                        filter: { type: 'none' }
                    },
                    hover: {
                        filter: { type: 'none' }
                    }
                },
                dataLabels: {
                    enabled: false
                },
                tooltip: {
                    custom: ({ series, seriesIndex, dataPointIndex, w }: any) => {
                        return '<div class="electricity-chart-tooltip">' +
                        '<small>' + w.globals.labels[dataPointIndex] + '</small>' +
                        + series[seriesIndex][dataPointIndex] + ' kWh</div>'
                    }
                },
                colors: ['#008B9A', '#293846'],
                chart: {
                    width: '100%',
                    toolbar: {
                        show: false,
                    },
                    events: {
                        dataPointSelection: (event, chartContext, config) => {
                            onDataPointClick(measurementData.measurements[config.dataPointIndex]);
                        }
                    }
                },
                xaxis: {
                    labels: {
                        rotate: 0
                    },
                    categories: measurementData.measurements.map((m: any) => moment(m.time).format(format))
                },
                yaxis: [
                    {
                        title: {
                            text: 'kWh'
                        }
                    }
                ]
            }} series={series} type="bar" height={320} /></div> : 
                null
            }
        </div>
    )
}